module.exports = __webpack_public_path__ + "img/pricing_2.4d134733.png";